import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { useField } from 'formik'
import { FC, useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@src/store/store'
import { setProfileField } from '@src/store/ducks/user/thunks'
import style from '@src/components/InfoProfileBlock/InfoProfileBlock.module.scss'
import cn from 'classnames'
import { ReactComponent as Edit } from '@src/assets/interface_edit.svg'
import { ReactComponent as Ok } from '@src/assets/interface-ок.svg'

type ProfileFieldProps = {
  placeholder: string
  name: string
  fieldId: number
}

export const ProfileField: FC<ProfileFieldProps> = ({ placeholder, name, fieldId }) => {
  const dispatch = useDispatch<AppDispatch>()
  const [field] = useField(name)
  const [isEdit, setIsEdit] = useState<boolean>(false)

  const submit = useCallback(() => {
    dispatch(setProfileField(fieldId, field.value))
    setIsEdit(false)
  }, [dispatch, field.value, fieldId])

  return (
    <div className={style.firstBox}>
      <div className={style.title}>{name}</div>
      <div className={style.addresses}>
        <div className={style.address}>
          <div className={cn(style.btn)}>
            {
            !isEdit
              ? <Edit onClick={() => { setIsEdit(true) }} />
              : <Ok onClick={() => submit()} />
          }
          </div>
          <FieldFormik
            placeholder={placeholder}
            name={name}
            className={cn(!isEdit && style.readOnly, isEdit && style.field)}
            disabled={!isEdit}
          />
        </div>
      </div>

    </div>
  )
}
